/* eslint-disable */
import axios from 'axios';


export default {

    state : {
        charges : [],
    },

   
    getters : {

        allCharges(state) {
            return state.charges.sort( (a,b)=>{return a.id > b.id ? -1 : 1});
        },

    },

    mutations: {
        addNewCharges(state, data) {
            data.forEach(element => {
                state.charges.push(element);
            });
        },

        setCharges(state, data) {
            state.charges = data;
        },

        deleteCharge(state, id) { // удаляем запись
            let index = state.charges.findIndex(item => item.id==id);
            state.charges.splice(index, 1);
        }

    },

    actions : {
        addNewCharges(context, data) {

            return new Promise((resolve, reject) => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                axios.post('/charges/add', data)  //Добавляем приходы
                .then(response => {
                    context.commit('addNewCharges', response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                });
             });
        },

        getCharges({dispatch, commit, rootState}) {
            
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;

            axios.get('/charges/50') //получаем последний 50 записей
                .then(response => {
                    commit('setCharges', response.data)                 
                })
                .catch(error => {
                    if ((error.response.status == 401)||(error.response.status == 500)) {
                        console.log(error);
                    }
                    else {
                        let t = error.response.status == 429 ? 15000 : 1500;  
                        if (error.response.headers["retry-after"] != undefined) t = error.response.headers["retry-after"];
                        setTimeout(()=>{        // повторная загрузка через секунду
                            dispatch('getCharges');
                        }, t);
                    }
                    reject(error.response.status)
                });

        },

        deleteCharge(context, id) {

            return new Promise((resolve, reject) => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;
                axios.delete('/charges/'+id)  //удаляем нахер приход
                .then(response => {
                    context.commit('deleteCharge', id);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                });
             });
        }

    }

}